import React from 'react'

const ColorsIcon = () => {
  return (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="inherit" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M7.5 0C8.32969 0 9 0.670313 9 1.5V19.5C9 19.6104 8.99601 19.7199 8.98819 19.8283C8.96368 20.1679 8.90144 20.4971 8.80565 20.8117C8.6675 21.2655 8.45953 21.6889 8.19429 22.0695C7.98327 22.3722 7.73598 22.6479 7.45875 22.8901C6.98632 23.3027 6.4269 23.6183 5.81169 23.8057C5.39666 23.9321 4.95623 24 4.5 24C2.01562 24 0 21.9844 0 19.5V1.5C0 0.670313 0.670313 0 1.5 0H7.5ZM22.5 24H8.56875L17.5687 15H22.5C23.3297 15 24 15.6703 24 16.5V22.5C24 23.3297 23.3297 24 22.5 24ZM20.4 7.92656C20.9859 8.5125 20.9859 9.46407 20.4 10.05L10.4812 19.964C10.4953 19.8094 10.5 19.6546 10.5 19.5V7.21875L14.0344 3.68438C14.6203 3.09844 15.5718 3.09844 16.1578 3.68438L20.4 7.92656Z" />
    </svg>
  )
}

export default ColorsIcon
